import AbstractAccountGroupRow from "./AbstractAccountGroupRow.js";

/**
 * Concrete row group used for Chart of accounts account groups.
 */
export default class AccountGroupRow extends AbstractAccountGroupRow {
	static getType() {
		return "AccountGroupRow";
	}
}
